var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"investor_relations"}},[_c('div',{staticClass:"cont"},[_c('SliderSection',{attrs:{"id":"investor-card","obj":_vm.investorRepo,"method":"getPage","sliderHolder":"investorRelations","data":_vm.info}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }